/* eslint-disable @nx/enforce-module-boundaries */
import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Tag,
  TagCloseButton,
  TagLabel,
} from '@mybridge/ui';
import { forwardRef, useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { MyProfileContext } from '../context';
import { SkillsDropdown } from 'v4/components/skills-dropdown';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
export const MyProfileSkillsModal = forwardRef(({ ...props }, ref) => {
  const {
    skillsDisc,
    addSkillLoading,
    mySkills,
    addSkill,
    removeSkills,
    removeSkillsLoading,
    refetchMySkills,
  } = useContext(MyProfileContext);
  const { t } = useTranslator();
  const [skills, setSkills] = useState(mySkills ?? []);
  const [newSkills, setNewSkills] = useState([]);
  const [deletedSkills, setDeletedSkills] = useState([]);

  useEffect(() => {
    if (JSON.stringify(mySkills) !== JSON.stringify(skills)) {
      setSkills(mySkills);
    }
  }, [mySkills]);

  useEffect(() => {
    const newSkills_ =
      skills?.filter?.(
        (s) => !mySkills?.find((ms) => ms?.id === s?.id || ms?.name === s?.name)
      ) ?? [];
    const deletedSkills_ =
      mySkills?.filter?.(
        (s) => !skills?.find((ms) => ms?.id === s?.id || ms?.name === s?.name)
      ) ?? [];

    setNewSkills(newSkills_);
    setDeletedSkills(deletedSkills_);
  }, [mySkills, skills]);

  const onClose = () => {
    skillsDisc?.onClose();
  };

  const onAdd = async (skill) => {
    const exists = skills?.find?.(
      (s) => s.id === skill.id || s.name === skill.name
    );
    if (!exists) {
      setSkills([...(skills ?? []), skill]);
    }
  };

  const onRemove = async (skill) => {
    const rest =
      skills?.filter?.((s) => s.id !== skill.id && s.name !== skill.name) ?? [];
    setSkills(rest);
  };

  const onSave = async () => {
    try {
      const pms = [];
      if (deletedSkills.length > 0) {
        pms.push(removeSkills(deletedSkills?.map((s) => s.id)));
      }
      if (newSkills.length > 0) {
        pms.push(addSkill(newSkills));
      }
      await Promise?.all(pms);
      skillsDisc?.onClose?.();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    // <Modal size="xl" {...(skillsDisc ?? {})} onClose={onClose}>
    //   <ModalOverlay />
    //   <ModalContent>
    //     <ModalHeader>
    //       Skill
    //       <ModalCloseButton />
    //     </ModalHeader>

    //   </ModalContent>
    // </Modal>
    <>
      <Stack spacing={4}>
        <FormControl variant="floating">
          <SkillsDropdown
            allowCreate
            onChange={onAdd}
            clearOnSelect={true}
            variant="whiteInput"
          >
            {({ value, onChange, disc, inputRef, onKeyUp, onKeyDown }) => (
              <Input
                ref={inputRef}
                value={value}
                onClick={(e) => disc?.onOpen?.()}
                onChange={(e) => onChange(e.target.value)}
                placeholder=" "
                onKeyUp={onKeyUp}
                onKeyDown={onKeyDown}
                autoFocus
                sx={{ textTransform: 'capitalize' }}
              />
            )}
          </SkillsDropdown>
          <FormLabel>{t('profileSkills.addSkills') || "Add skills"}</FormLabel>
          <FormErrorMessage>{t('profileSkills.skillsRequired') || "Skills are required"}</FormErrorMessage>
        </FormControl>
        {skills?.length ? (
          <HStack spacing={0} gap={4} flexWrap="wrap">
            {skills?.map?.((sk, skInd) => (
              <Tag p={2} key={skInd} borderRadius="full">
                <TagLabel pl={2}>{sk?.name}</TagLabel>
                <TagCloseButton pr={2} onClick={(e) => onRemove(sk)} />
              </Tag>
            ))}
          </HStack>
        ) : (
          ''
        )}
      </Stack>
      <HStack flex={1} justifyContent="flex-end" mt={4}>
        <Button  borderRadius="50px" variant="secondary" onClick={(e) => skillsDisc?.onClose?.()}>
          {t('buttons.cancel') || "Cancel"}
        </Button>
        <Button
          isDisabled={newSkills?.length <= 0 && deletedSkills?.length <= 0}
          isLoading={addSkillLoading || removeSkillsLoading}
          onClick={onSave}
          variant="primary"
          borderRadius="50px"
        >
          {t('buttons.save') || "Save"}
        </Button>
      </HStack>
    </>
  );
});
